import React from "react";
// import { SkeletonComponentProps } from 'src/app/models/Site';
import { LegalesLink } from "src/app/views/components/PromotionsView/components";

// TODO : traer la info de un publication y no del skeleton component
export const SkeletonLegales = () => <LegalesLink title="Ver legales" />;
